/* globals google */
import { hash } from "../utils.ts"
import { translateService } from './TranslateService.ts'
import {IParams} from "../types/params.interface.ts";

class InstallService {
	inProgress = false
	installed = false
	params: IParams
	cb: (() => void) | false
	observer: MutationObserver

	setParams (params: IParams) {
		this.params = params
	}

	setAutoInstall(time: number){
		setTimeout(this.install.bind(this), time) //self install
	}

	setCB (cb: () => void) {
		this.cb = cb
	}

	install () {
		if (this.installed === true) return
		if (this.inProgress === true) return
		this.inProgress = true
		let scriptTag = document.createElement('script')
		scriptTag.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=' + this.registerCB())
		document.body.appendChild(scriptTag)
	}

	registerCB()
	{ 
		let name
		do {
			name = `GoogleTranslate_${hash(10)}`
		} while(window[name] !== undefined)

		// @ts-ignore
		window[name] = this.afterInstall()
		return name
	}

	afterInstall () {
		return () => {
			this.inProgress = false
			this.installed = true
			new google.translate.TranslateElement({pageLanguage: this.params.siteLanguage, includedLanguages: this.params.languages.map(item => item.shortCode).join(','), autoDisplay: false}, 'original-google-translate')

			Array.apply(null, document.querySelectorAll('link[href="https://translate.googleapis.com/translate_static/css/translateelement.css"]')).forEach(function (node: Node) {
				node.parentNode.removeChild(node)
			})

			document.getElementsByTagName('body')[0].classList.add('gt')
			this.observe() 
		}
	}

	observe() {
		this.observer = new MutationObserver(this.check.bind(this))
		this.observer.observe(document.querySelector('.goog-te-combo'), {attributes: true, childList: true, subtree: true })
	}
	
	check() {
		if(document.querySelector('.goog-te-combo').querySelectorAll('option')) {
			this.observer.disconnect()
			translateService.setGTWidget(document.querySelector('.goog-te-combo'));
			if(this.cb) {
				this.cb()
				this.cb = false
			}
		}
	}
}

const installService = new InstallService()
export {
	InstallService,
	installService
}
